import React from 'react'
import { makeStyles, createStyles, AppBar, Box } from '@material-ui/core'
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      top: 'auto',
      bottom: 0,
      backgroundColor: theme.palette.background.paper,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),

      minHeight: theme.spacing(6.5),
    },
  }),
)

const FixedButtonWrapper = ({ children }) => {
  const classes = useStyles()
  return (
    <AppBar className={classes.root} position="fixed" component="div">
      <Box px={2}>{children}</Box>
    </AppBar>
  )
}

export default FixedButtonWrapper
